module.exports = __webpack_public_path__ + "static/media/rr-desktop.80d1778b.png";